import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const OhlcIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M0,19.673224541467928L0,0M0,14.572914289047588L-11.999987936887127,14.572914289047588M0,3.6744905765561624L11.999987936887127,3.6744905765561624"
        transform="translate(12,0)"
        stroke={props.htmlColor ?? '#18bdac'}
        fill={props.htmlColor ?? '#18bdac'}
        strokeWidth="2"
      ></path>
    </SvgIcon>
  );
};

export default OhlcIcon;
